import { NicheListWidgetAlive } from "@/components/widgets/NicheListWidgetAlive";
import { routes } from "@/common/utils/routes";
import { useSuggestedNiches } from "./hooks/useSuggestedNiches";
import { FeedModuleTypeEnum } from "@/common/services/types";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";

interface IProps {
  page: number;
  listSize?: number;
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const SuggestedNichesModule = ({ page, listSize, moduleId, moduleType }: IProps) => {
  const { niches, error } = useSuggestedNiches();

  if (niches.length === 0) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      {error ? (
        <p>Error loading niches.</p>
      ) : (
        <NicheListWidgetAlive
          className="trendingBlock trendingNiches"
          title="Suggested Niches"
          link={routes.niches()}
          niches={niches}
          listSize={listSize}
          page={page}
        />
      )}
    </FeedModuleContainer>
  );
};
